$(document).ready(function () {
    heightFaq()
})

$(document).on('click', '.js_faq__title, .js_faq__btn', function () {
    let wrapper = $(this).closest('.js_faq__item')
    if (!wrapper.hasClass('active')) {
        closeFaq()
        openFaq(wrapper)
    } else {
        closeFaq()
    }
})

$(window).on('resize', function () {
    heightFaq()
})

function openFaq(wrapper) {
    let title = wrapper.find('.js_faq__title')
    let text = wrapper.find('.js_faq__text')

    title.removeAttr('style').removeClass('faq__title_big')
    text.slideDown()
    wrapper.addClass('active')
}

function closeFaq() {
    $('.js_faq__text').slideUp()
    $('.js_faq__item').removeClass('active')
    heightFaq()
}

function heightFaq() {
    $('.js_faq__item').each((i, el) => {
        if (!$(el).hasClass('active')) {
            let title = $(el).find('.js_faq__title')
            let lines = parseInt((title[0].scrollHeight - parseInt(title.css('padding-top')) - parseInt(title.css('padding-bottom')))/ parseInt(title.css('line-height')))
            if (lines > 4 && $(document).width() < 568) {
                title.addClass('faq__title_big')
            } else if (lines > 2 && $(document).width() > 567) {
                title.addClass('faq__title_big')
            } else {
                title.removeClass('faq__title_big')
            }
        }
    })
}